import script from "./WorkflowNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./WorkflowNavigation.vue?vue&type=style&index=0&id=1057563c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1057563c"]])

export default __exports__